import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["filterButton", "viewButton", "unchanged"];
  static values = { storageKey: String };

  connect() {
    const preferences = this.preferences;
    this.filter = this.hasUnchangedTarget
      ? preferences.filter || "changes"
      : "changes";
    this.view = preferences.view || "unified";
    this.apply();
  }

  selectFilter({ params: { filter } }) {
    this.filter = filter;
    this.apply();
    this.save();
  }

  selectView({ params: { view } }) {
    this.view = view;
    this.apply();
    this.save();
  }

  syncFilter() {
    if (!this.hasUnchangedTarget) return;

    this.filter = this.unchangedTarget.open ? "all" : "changes";
    this.updateButtons(this.filterButtonTargets, "filter", this.filter);
    this.save();
  }

  apply() {
    if (this.hasUnchangedTarget) {
      this.unchangedTarget.open = this.filter === "all";
    }

    this.element.classList.toggle(
      "step-details-component--split",
      this.view === "split",
    );
    this.updateButtons(this.filterButtonTargets, "filter", this.filter);
    this.updateButtons(this.viewButtonTargets, "view", this.view);
  }

  updateButtons(buttons, parameter, selected) {
    buttons.forEach((button) => {
      const active =
        button.dataset[
          `stepDetailsReviewComponent${this.capitalize(parameter)}Param`
        ] === selected;
      button.setAttribute("aria-pressed", active);
    });
  }

  save() {
    if (!this.hasStorageKeyValue) return;

    sessionStorage.setItem(
      this.storageKeyValue,
      JSON.stringify({ filter: this.filter, view: this.view }),
    );
  }

  get preferences() {
    if (!this.hasStorageKeyValue) return {};

    try {
      return JSON.parse(sessionStorage.getItem(this.storageKeyValue)) || {};
    } catch {
      return {};
    }
  }

  capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
